import React, { useState, useEffect, Fragment } from 'react';
import { TextField, Box, Button, CircularProgress, Typography, Card, CardActions, CardContent, CardHeader, DateTime } from '@mui/material';

import { useNotify } from 'react-admin'
import client from '../common/client';
import Help from '../component/Help'

const ProjectLoadingField = props => {
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [loadingColor, setLoadingColor] = React.useState('');

    const save = (e) => {
        setLoading(true)
        client.request_post(`/api/project/color`, {
            project_id: props.project.id,
            color: loadingColor,
        }).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Loading Color Saved`);
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    useEffect(() => {
        setLoadingColor(props.project.loading_color)
    }, [props.project])

    return (
        <Card >
            <CardHeader
                title="Loading Color to Github"
                action={
                    <Help />
                }
            />
            <CardContent>
                <Box>
                    {/* #F2632A */}
                    <TextField label="color(#ffffff)" value={loadingColor} onChange={(e) => {
                        setLoadingColor(e.target.value)
                    }} />
                </Box>
            </CardContent>
            <CardActions>
                <Box m={1}>
                    <Button variant="contained" color="primary" startIcon={loading && <CircularProgress size={24} />} onClick={save} disabled={loading}>
                        Save to github</Button>
                </Box>
            </CardActions>
        </Card>
    );
};

export default ProjectLoadingField;
